import SmallText from './SmallText'

export default SmallText
